import React from 'react';
import { History } from 'history';
import { Input, InputSelect, InputTime, InputMultiline, InputSwitch, InputPicklist } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './schedule-model';  //editable..
import OwnerPicklist from '../owner/owner-picklist.component';
import DivisionPicklist from '../division/division-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class ScheduleEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadDivision = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'division': data?.id, 'divisionCaption': data?.name || ''  }  });
    }  

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]:  value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} 
                model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                } 
                <InputSelect name='day' label='Day' value={this.state.datarow.day} options={Model.optionDay} error={this.state.errors?.day} onChange={this.onChange} />
                <InputTime name='time' label='Time' value={this.state.datarow.time} clearValue error={this.state.errors?.time} onChange={this.onChange} />
                <InputPicklist name='division' label='Division' value={this.state.datarow.division} caption={this.state.datarow.divisionCaption} clearValue={this.onLoadDivision} error={this.state.errors?.division} onChange={this.onChange} >
                    <DivisionPicklist currentId={this.state.datarow.division} onLoad={this.onLoadDivision}/>
                </InputPicklist>
                
            </BaseEdit>
        );
    }
}